import { jsx as _jsx } from "react/jsx-runtime";
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../features/home/context/ThemeContext';
import '../../styles/navigation.css';
const NavThemeToggle = () => {
    const { resolvedTheme, toggleTheme } = useTheme();
    const isDark = resolvedTheme === 'dark';
    return (_jsx("button", { type: "button", onClick: toggleTheme, className: "cfn-nav-theme-toggle", "aria-label": `Switch to ${isDark ? 'light' : 'dark'} theme`, title: `Switch to ${isDark ? 'light' : 'dark'} theme`, children: isDark ? (_jsx(Sun, { className: "h-5 w-5" })) : (_jsx(Moon, { className: "h-5 w-5" })) }));
};
export default NavThemeToggle;
